/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  Col,
  DatePicker,
  DatePickerProps,
  Dropdown,
  Form,
  Input,
  Row,
  Select,
  Space,
  Table,
} from 'antd';
import {
  CancelIcon,
  Cart,
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
  Order,
  OrderHistory,
  CheckIcon,
  Remove,
  ChevronDown,
} from 'assets/svg';
import dayjs from 'dayjs';
import { MainLayout } from 'components';
import { Content } from 'antd/es/layout/layout';
import Button from 'components/Button';
import { useEffect, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import formatDateMDY from 'utils/formatDateMDY';
import { ColumnsType } from 'antd/es/table';
import { HocChangePagination } from 'utils/HocChangePagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import CartApi from 'apis/CartApi';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { useUser } from 'contexts/User';
import { useForm } from 'antd/es/form/Form';
import PofTypeApi from 'apis/PofTypeApi';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import formatDate from 'utils/formatDate';
import ApprovalApi from 'apis/ApprovalApi';
import { approvalStatus } from 'mock/approve-mockup';
import convertStatusApproveOrder from 'constants/approveOrderStatus';
import { ColumnGroupType } from 'antd/lib/table';
import moment from 'moment';

type FixedType = 'left' | 'right' | boolean;

export default function ListApproveOrder() {
  const history = useHistory();
  const { user } = useUser();
  const [form] = useForm();
  const { Option } = Select;

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [formSubmitParams, setFormSubmitParams] = useState<any>();

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      console.log('fgdvsf', filteredData[key]);
      if (key == 'order_at') {
        stringifiedData[key] = moment(String(filteredData[key])).format(
          'MM/DD/YYYY'
        );
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });

    setFormSubmitParams(stringifiedData);
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const params = {
    page: page,
    page_size: page_size,
    ...(formSubmitParams && formSubmitParams),
  };

  const {
    data: listApproveOrder,
    isLoading: approveOrderLoading,
    mutate: refetch,
  } = useMutation(['get'], () =>
    user?.role.includes('nguoi_dat_hang') ||
    user?.role.includes('cua_hang_truong')
      ? ApprovalApi.getApproveOrderCHT(params, user?.plantId)
      : ApprovalApi.getCartOrderBranch(params)
  );

  const { data: lstPofType } = useQuery(['getAll'], () =>
    PofTypeApi.getCartType()
  );

  useEffect(() => {
    setTitle('Phê duyệt đặt hàng');
    setBreadcrumb([
      {
        title: (
          <p>
            <a>Phê duyệt</a>{' '}
          </p>
        ),
      },
      { title: <a href="">Phê duyệt đặt hàng</a> },
    ]);
    if (user) {
      refetch();
    }
  }, [page, page_size, formSubmitParams, user]);

  const columnByRole =
    user?.role.includes('nguoi_dat_hang') ||
    user?.role.includes('cua_hang_truong')
      ? []
      : user?.plantCode == 1000
      ? [
          {
            title: 'CH đã đăng ký',
            width: 130,
          },
          {
            title: 'CN đã đăng ký',
            width: 130,
          },
        ]
      : [];
  const hideColumn = user?.role.includes('asm') ? false : true;
  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    hideColumn
      ? {
          title: 'Mã đơn hàng',
          dataIndex: 'order_code',
          width: 150,
        }
      : {},
    hideColumn
      ? {
          title: 'Trạng thái',
          dataIndex: 'status',

          width: 130,
          render: (_: any, record: any) => {
            return convertStatusApproveOrder(record?.status);
          },
        }
      : {},
    {
      title: 'Mã giỏ hàng',
      dataIndex: 'cart_code',
      width: 130,
    },
    {
      title: 'Tên giỏ hàng',
      width: 250,
      dataIndex: 'cart_name',
    },

    ...columnByRole,

    {
      title: 'Danh mục hàng hóa',
      dataIndex: user?.role.includes('cua_hang_truong')
        ? 'cart_type_name'
        : 'pof_type_name',
      width: 170,
    },
    hideColumn
      ? {
          title: 'SL đăng ký',
          width: 150,
        }
      : {},

    {
      title: 'Vốn đăng ký tối thiểu (Min)',
      dataIndex: user?.role.includes('cua_hang_truong')
        ? 'capital_min'
        : 'von_dk_min',

      width: 220,
      render: (value) => {
        return <p>{formatCurrencyVND(value)}</p>;
      },
    },
    {
      title: 'Vốn đăng ký tối đa (Max)',
      dataIndex: user?.role.includes('cua_hang_truong')
        ? 'capital_max'
        : 'von_dk_max',

      width: 200,
      render: (value) => {
        return <p>{formatCurrencyVND(value)}</p>;
      },
    },
    hideColumn
      ? {
          title: 'Bộ phận phát triển',
          width: 200,
        }
      : {},
    hideColumn
      ? {
          title: 'Người đặt hàng',
          width: 200,
          dataIndex: 'orderer_name',
        }
      : {},
    hideColumn
      ? {
          title: 'Người phê duyệt',
          width: 200,
        }
      : {},

    {
      title: 'Ngày gửi phê duyệt',
      width: 200,
      render: (_: any, record: any) => {
        return record.request_date ? formatDate(record.request_date) : '';
      },
    },
    hideColumn
      ? {
          title: 'Ngày phê duyệt',
          width: 200,
          dataIndex: 'approve_date',
          render: (_: any, record: any) => {
            return record.approve_date ? formatDate(record.approve_date) : '';
          },
        }
      : {},

    {
      title: 'Ngày đặt hàng',
      width: 160,
      dataIndex: 'order_at',
      render: (_: any, record: any) => {
        return record.order_at ? formatDate(record.order_at) : '';
      },
    },
    hideColumn
      ? {
          title: 'Số cấp phê duyệt',
          width: 200,
        }
      : {},
    hideColumn
      ? {
          title: 'Số lần phê duyệt',
          width: 200,
        }
      : {},

    {
      fixed: 'right',
      width: 130,
      align: 'center',
      render: (record) => {
        return (
          <button
            onClick={() => {
              history.push(`/declare`, { cart: record });
            }}
          >
            <EyeIcon />
          </button>
        );
      },
    },
  ];

  columns.filter((col) => col.dataIndex !== 'id');

  return (
    <MainLayout>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1"
      >
        <Col span={12} className="flex justify-end">
          <Space>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>
      <Form
        form={form}
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'}`}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Content className="mt-4">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={6}>
              <Form.Item name="search_cart_name" label="Tìm kiếm tên giỏ hàng">
                <Input placeholder="Tìm kiếm theo tên giỏ hàng" className="" />
              </Form.Item>
            </Col>
            <Col className="" span={6}>
              <Form.Item name="pof_type_code" label="Loại giỏ hàng">
                <Select placeholder="Chọn loại giỏ hàng">
                  {lstPofType?.data?.map((item) => (
                    <Option value={item.pof_type_code} key={item.id}>
                      {item.pof_type_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {hideColumn && (
              <Col className="" span={6}>
                <Form.Item name="order_at" label="Ngày gửi phê duyệt">
                  <DatePicker
                    format={'DD/MM/YYYY'}
                    placeholder="DD/MM/YYYY"

                    // defaultValue={dayjs('18-01-2024', 'DD-MM-YYYY')}
                  />
                </Form.Item>
              </Col>
            )}
            {hideColumn && (
              <Col className="" span={6}>
                <Form.Item name="status" label="Trạng thái">
                  <Select placeholder="Chọn trạng thái">
                    {approvalStatus.map((item) => (
                      <Option value={item.value} key={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={handleReset}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          dataSource={listApproveOrder?.data}
          scroll={{ x: 958 }}
          loading={approveOrderLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: listApproveOrder?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
}
